import React from "react";
import EvidencePin from "./EvidencePin";

export const StickyNote = ({
  color = "yellow",
  pin = "black",
  rotate = -2,
  className = "",
  children,
}) => (
  <aside
    className={`sticky-note sticky-note--${color} ${className}`}
    style={{ transform: `rotate(${rotate}deg)` }}
  >
    {pin ? <EvidencePin color={pin} size="sm" className="sticky-note-pin" /> : null}
    {children}
  </aside>
);

export default StickyNote;
